export const isMobileUserAgent = (userAgent?: string) => {
  if (!userAgent && typeof window === 'undefined') {
    return false
  }

  const ua = userAgent || window.navigator.userAgent

  return /iPhone|iPad|Android/i.test(ua)
}
